import { faArrowUpFromBracket } from '@fortawesome/pro-regular-svg-icons'
import { AIVectorStoreType } from 'types/graphql'

import { FilesInput } from 'src/components/form/FilesInput'
import Modal from 'src/components/Modal'
import { AcceptedDocx, AcceptedPdf } from 'src/constants'
import { PathPrefixes } from 'src/constants/file'
import {
  useUploadAITrainingMaterialFilesMutation,
  useGetAllAITrainingMaterialsQuery,
} from 'src/fetch/aiTrainingMaterials'
import { UseDisclosureReturn } from 'src/hooks/use-disclosure'
import { UploadMultipleFilesFileUploadState } from 'src/hooks/use-files-upload-state'

type Props = {
  modalState: UseDisclosureReturn
  vectorStoreType: AIVectorStoreType
}

interface FormValues {
  files: UploadMultipleFilesFileUploadState[]
}

const UploadAITrainingMaterialsModal = ({ modalState, vectorStoreType }: Props) => {
  const { mutateAsync: uploadFn } = useUploadAITrainingMaterialFilesMutation()
  const { refetch } = useGetAllAITrainingMaterialsQuery(vectorStoreType)
  const onOk = async ({ files }: FormValues) => {
    const fileIds = files.flatMap((f) => (f.govWellFileId ? [f.govWellFileId] : []))
    if (fileIds.length > 0) {
      await uploadFn({ input: { fileIds, vectorStoreType } })
      await refetch()
    }
  }
  return (
    <Modal
      {...modalState}
      icon={faArrowUpFromBracket}
      title="Upload Training Materials"
      okText="Upload"
      form
      onOk={onOk}
    >
      <FilesInput
        label="Files"
        fieldName="files"
        uploadParams={{
          pathPrefix: PathPrefixes.DocumentTemplates,
          // PDF and DOCX are fine for now, but technically more file types are supported: https://platform.openai.com/docs/guides/tools-file-search#supported-files
          accept: `${AcceptedPdf}, ${AcceptedDocx}`,
        }}
      />
    </Modal>
  )
}

export default UploadAITrainingMaterialsModal
